import * as React from "react";

const IconPaginationLeft: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="currentColor"><polygon fill="currentColor" points="10 39 0 48 0 30" transform="matrix(-1 0 0 1 10 -30)"/></svg>;
};

export default React.memo(IconPaginationLeft);
